export const apiActionsBillingReports = {
    GET_BILLING_REPORT: "GET_BILLING_REPORT",
    GET_UPLOAD_SAP_FILE: "GET_UPLOAD_SAP_FILE",
    GET_SAP_USAGE_CONTROL_FILE: "GET_SAP_USAGE_CONTROL_FILE",
    GET_SAP_INPUT_FILE: "GET_SAP_INPUT_FILE",
    POST_MONTHLY_ROLLUP: "POST_MONTHLY_ROLLUP",
    POST_UPDATE_LINKS: "POST_UPDATE_LINKS",
    POST_BILLING_REPORT: "POST_BILLING_REPORT",
    POST_RUN_PRICING: "POST_RUN_PRICING",
    GET_SAP_UPLOAD_STATUS: "GET_SAP_UPLOAD_STATUS",
}

export const billingReportsActionTypes = {
    SHOW_RUN_MESSAGE: "SHOW_RUN_MESSAGE",
    SHOW_DOWNLOAD_MESSAGE: "SHOW_DOWNLOAD_MESSAGE",
    HIDE_RUN_MESSAGE: "HIDE_RUN_MESSAGE",
    HIDE_DOWNLOAD_MESSAGE: "HIDE_DOWNLOAD_MESSAGE",
    SHOW_DB_LOADING: "SHOW_DB_LOADING",
    SHOW_DS_LOADING: "SHOW_DS_LOADING",
    SHOW_UL_LOADING: "SHOW_UL_LOADING",
    SHOW_MR_LOADING: "SHOW_MR_LOADING",
    SHOW_RP_LOADING: "SHOW_RP_LOADING",
    SHOW_RB_LOADING: "SHOW_RB_LOADING",
    TOGGLE_UPDATE_SAP_WARNING: "TOGGLE_UPDATE_SAP_WARNING",
    UPDATE_SAP_UPLOAD_STATUS: "UPDATE_SAP_UPLOAD_STATUS",
    CLEAR_BILLING_REPORT_DETAILS: "CLEAR_BILLING_REPORT_DETAILS",
}
